import React, { memo } from "react";

export const CalendarAgenda = memo(
  (props: { selectedDate: Date; renderAgendaItem: (dayOfMonth: number) => JSX.Element }) => {
    return <div className="ui-calendar-agenda"></div>;
  },
);

CalendarAgenda.displayName = "CalendarAgenda";
